import {MechanicValidatorLargestArmy} from '@colonist/game-mechanic-validators'
import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {useMapValidator} from './useMapValidator'
import {usePlayerValidators} from './usePlayerValidators'

export const useMechanicValidatorLargestArmy = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const mechanicLargestArmyState = useGameStore((state) => state.gameState.mechanicLargestArmyState)

    return useMemo(() => {
        if(!mechanicLargestArmyState) return undefined
        return new MechanicValidatorLargestArmy(playerValidators, mapValidator, mechanicLargestArmyState)
    }, [playerValidators, mapValidator, mechanicLargestArmyState])
}
